import Vue from 'vue'

Vue.directive('input-class', {
    inserted: function (el) {
        if (el.value !== null && el.value != "")
            el.classList.add('input--set');
    },
    update: function (el) {
        if (el.value !== null && el.value != "")
            el.classList.add('input--set');
        else
            el.classList.remove('input--set');
    }
});